const fr = {
  nav: {
    home: 'Accueil',
    blog: 'Blog',
    resume: 'CV',
  },
  lang: {
    en: 'EN',
    pt: 'PT',
    fr: 'FR',
  },
  jobTitle: 'Ingénieur Logiciel Full-Stack & Architecte',
  home: {
    available: 'Disponible pour de nouvelles opportunités',
    headline1: 'Bonjour, je suis',
    heroPart1: "J'adore créer des ",
    descriptionBold: 'solutions évolutives, optimisées et performantes',
    heroPart2: ' pour les entreprises et partager mes connaissances à travers l\'écriture.',
    badge1: 'Expert .NET',
    badge2: 'Full Stack',
    ctaBlog: 'Lire mon blog',
    ctaResume: 'Voir le CV',
    findMeOn: 'Retrouvez-moi sur :',
    whatIDo: {
      title: 'Ce Que Je Fais',
      subtitle: 'Je me spécialise dans la création d\'applications robustes et évolutives sur toute la pile',
      cards: [
        {
          icon: '🏗️',
          title: 'Architecture Système',
          description: 'Conception de microservices, d\'APIs et de systèmes distribués qui évoluent.',
        },
        {
          icon: '💻',
          title: 'Développement Full-Stack',
          description: 'Création de solutions complètes avec .NET, React, Flutter et les technologies cloud.',
        },
        {
          icon: '✍️',
          title: 'Rédaction Technique',
          description: 'Partage d\'insights sur les design patterns, les bonnes pratiques et la culture d\'ingénierie.',
        },
      ],
    },
  },
  resume: {
    relevantExperience: 'Expérience Pertinente',
    lastExperience: 'Dernière Expérience',
    skills: 'Compétences',
    education: 'Formation',
    languages: 'Langues',
    selectedProjects: 'Projets Sélectionnés',
  },
  footer: {
    rights: 'Tous droits réservés.',
    builtWith: 'Créé avec React & ❤️',
  },
  blog: {
    featuredTitle: 'Articles Récents',
    featuredSubtitle: 'Réflexions sur l\'ingénierie et l\'architecture',
    viewAll: 'Voir tout',
    viewAllArticles: 'Voir tous les articles',
    readMore: 'En savoir plus',
    backToBlog: 'Retour au Blog',
    backToHome: 'Accueil',
    minuteRead: 'min de lecture',
    searchPlaceholder: 'Rechercher des articles...',
    all: 'Tout',
    noPostsFound: 'Aucun article trouvé',
    noPostsSubtitle: 'Essayez d\'ajuster vos termes de recherche',
    noPostsAvailable: 'Aucun article disponible pour le moment.',
    clearFilters: 'Effacer les filtres',
    article: 'article',
    articles: 'articles',
    failedToLoad: 'Échec du chargement des articles du blog.',
    tryAgain: 'Réessayer',
    featured: 'À la une',
    backToTop: 'Haut',
    relatedArticles: 'Articles Connexes',
    categories: {
      'design-patterns': 'Design Patterns',
      'system-architecture': 'Architecture Système',
      'frontend-patterns': 'Frontend Patterns',
      'tooling': 'Outillage',
      'best-practices': 'Bonnes Pratiques',
    },
  },
};

export default fr;
